require('./hireCardMetallicStep4.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKMessage } = require('commonsComponents/OKMessage');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const HireCardMetallicStep4SummaryWithValidation = require('./hireCardMetallicStep4SummaryWithValidation');
const HireCardMetallicStep4SummaryWithoutValidation = require('./hireCardMetallicStep4SummaryWithoutValidation');

// @constants
const { FOURTH_STEP } = require("constants/index");
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { METALLIC_GDPR_PID } = require('constants/gdprPlacementIds');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    METALLIC,
    messages: {METALLIC_AND_GDPR}
} = require('constants/operationTypes');

const {
    METALLIC_CARD_PRODUCT_ALIAS,
    METALLIC_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');

class hireCardMetallicStep4 extends React.Component {
    componentDidMount() {
        const { sendPrecontractualDocumentMail } = this.props;
        const precontractualMailProductInfo = {
            productAlias: METALLIC_CARD_PRODUCT_MIN_ALIAS,
            productName: METALLIC_CARD_PRODUCT_ALIAS,
        };

        sendPrecontractualDocumentMail(
            precontractualMailProductInfo,
            false,
            true
        );

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            this.props.setTermsAndCondsText(
                "hireCardMetallic-hireCardMetallic_confirmationStepAgreementText"
            );
        }
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardNameSelector,
            immHireCardMetallic,
            immShippingAddress,
            originCountry,
            immMetalCard,
            applyMetalCardValidations,
        } = this.props;
        return applyMetalCardValidations ? (
            <HireCardMetallicStep4SummaryWithValidation
                immAccounts={immAccounts}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCardMetallic={immHireCardMetallic}
                immShippingAddress={immShippingAddress}
                originCountry={originCountry}
                immMetalCard={immMetalCard}
            />
        ) : (
            <HireCardMetallicStep4SummaryWithoutValidation
                immAccounts={immAccounts}
                immHireCardNameSelector={immHireCardNameSelector}
                immHireCardMetallic={immHireCardMetallic}
                immShippingAddress={immShippingAddress}
                originCountry={originCountry}
            />
        );
    }

    render() {
        const { immHireCardMetallic, operativeName, immPdfData } = this.props;
        const immStep = immHireCardMetallic.getIn(["steps", FOURTH_STEP]);
        const agreementLabel = (
            <FormattedText value="hireCardMetallic-hireCardMetallic_confirmationStepAgreementText" />
        );
        const agreementChecked = immStep.get("agreementChecked");
        const agreementErrorVisible =
            immStep.get("agreementIsDirty") && !immStep.get("agreementChecked");
        const agreementErrorMsg = formatText(
            "hireCardMetallic-step3CheckboxErrorMsg"
        );
        const pdfError = immPdfData.get("errorContent");
        const summaryContent = this.buildSummary();
        const hireCardTitleClassName = contactCenterClassName(
            "print-title",
            "hire-card-metallic-step-four__title"
        );
        const hireCardSubTitleClassName = contactCenterClassName(
            "print-paragraph",
            "hire-card-metallic-step-four__subtitle"
        );
        const operationParams = [
            {
                serviceCode: METALLIC,
            },
            {
                serviceCode: ADD_NEW_SHIPPING_ADDRESS,
            },
        ];
        const preContractDocumentInfo = getCardsPreContractPdfData()[
            "metallic_card"
        ];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if (!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-metallic-step-four__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardMetallicAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={this.props.handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            );
        }

        if (agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={METALLIC_AND_GDPR}
                />
            );
        }

        return (
            <article className="hire-card-metallic-step-four">
                <FormattedText
                    className={hireCardTitleClassName}
                    value="hireCardMetallic-step3Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className={hireCardSubTitleClassName}
                    value="hireCardMetallic-step3Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={METALLIC_GDPR_PID} />
                <WebappRender>
                    <div className="hire-card-metallic-step-four__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePrecontractual"
                        />
                    </div>
                </WebappRender>
                <div className="hire-card-metallic-step-four__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText
                            value="hireCardMetallic-addressHint"
                            className="no-print-out"
                        />
                    </OKMessage>
                </div>
                {agreementCheckboxContent}
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

hireCardMetallicStep4.propTypes = {
    applyMetalCardValidations: PropTypes.bool.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMetallic: PropTypes.object.isRequired,
    immPdfData: PropTypes.object,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    originCountry: PropTypes.string.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    immMetalCard: PropTypes.object.isRequired
};

module.exports = hireCardMetallicStep4;
